
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/zakat",
      function () {
        return require("private-next-pages/zakat/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/zakat"])
      });
    }
  